<template>
  <div class="home">
    <Calendar v-if="isReady" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Calendar from './Calendar';

export default {
  name: 'home',
  data() {
    return {
      isReady: false,
    };
  },
  created() {
    this.getBusinessInfo()
      .then(this.getAppointmentTypes)
      .then(() => {
        this.isReady = true;
      }).catch(() => {
        // @todo figure out what to do if business info error? maybe logout?
      });
  },
  methods: {
    ...mapActions([
      'getBusinessInfo',
      'getAppointmentTypes',
    ]),
  },
  components: {
    Calendar,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Home.vue